import { Button, Table, Tooltip } from "flowbite-react";
import { HiPencil } from "react-icons/hi";
import useCategories from "../hooks/useCategories";
import { Category } from "../types/categories";
import { useReducerAsState } from "../hooks/useReducerAsState";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../routes";
import { TableResults } from "../components";
import { useAuth } from "../context/authContext";

const staticSections = [
  {
    id: 9225012,
    name: "Home",
    parent_name: "root",
    slug: "home",
  },
  {
    id: 9225013,
    name: "Edición Impresa",
    parent_name: "root",
    slug: "edicion-impresa",
  },
  {
    id: 9225014,
    name: "Detalles de la nota",
    parent_name: "root",
    slug: "detalles-de-la-nota",
  },
];

interface State {
  sections: Array<Category>;
}

const AdsSectionsScreen = () => {
  const { permissions } = useAuth();

  const canEdit = permissions.find((item) => item.slug === "editar-publicidad");

  const { categories, fetchCategories, loadingCategories, errorCategories } =
    useCategories();
  const navigate = useNavigate();

  const [state, setState] = useReducerAsState<State>({
    sections: [],
  });

  useEffect(() => {
    if (!categories) return;

    const newCategories = [...staticSections, ...categories];
    setState({ sections: newCategories });
    // eslint-disable-next-line
  }, [categories]);

  useEffect(() => {
    (async () => {
      await fetchCategories();
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="m-4">
      <div className="flex flex-col mb-4">
        <div className="mb-4">
          <h1>Publicidad de Secciones</h1>
        </div>
      </div>
      <TableResults
        loading={loadingCategories}
        error={errorCategories}
        itemsCount={categories.length}
      >
        <div className="overflow-x-auto mb-4 w-full bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
          <Table hoverable>
            <Table.Head>
              <Table.HeadCell>Título</Table.HeadCell>
              <Table.HeadCell>Acciones</Table.HeadCell>
            </Table.Head>
            <Table.Body className="divide-y">
              {state.sections &&
                state.sections.map((item) => (
                  <Table.Row
                    className="bg-white dark:border-gray-700 dark:bg-gray-800"
                    key={item.id}
                  >
                    <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                      {item.name}
                    </Table.Cell>
                    <Table.Cell>
                      {canEdit && (
                        <Button
                          color="gray"
                          onClick={() =>
                            navigate(
                              `${routes.DASHBOARD}/${routes.ADS_SECTIONS}/${item.id}`
                            )
                          }
                        >
                          <Tooltip content="Editar">
                            <HiPencil />
                          </Tooltip>
                        </Button>
                      )}
                    </Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
        </div>
      </TableResults>
    </div>
  );
};

export default AdsSectionsScreen;
